export default __webpack_public_path__ + "5297981c7bbe51f22db7f9cca9de14a9.png";